module.exports = __webpack_public_path__ + "static/media/办公楼楼宇智能化管理1.70ea10de.jpg";